import React, { useState, useContext, useEffect, useCallback } from "react";
import { makeStyles, Card, Typography, Grid } from "@material-ui/core";
import { LangContext } from "../../../Context/Langcontext";
import { ServiceContext } from "../../../Context/ServiceContext";
import { FaCircle } from "react-icons/fa";
import Imageservice from "../../../API/Imageservice";
import { getoneAPIkey } from "../../../API/apikey";

// const fs = require("fs");

const useStyle = makeStyles((theme) => ({
  root: {
    width: "95%",
    height: "95%",
  },
  card: {
    width: "100%",
    height: "auto",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "unset",
    marginTop: "2rem",
    marginBottom: "2rem",
  },
  cardapi: {
    width: "100%",
    height: "auto",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginBottom: "2rem",
  },
  maintext: {
    fontSize: "1.2rem",
    fontWeight: 700,
    color: "#595A5A",
  },
  detailtext: {
    fontSize: "1rem",
    fontWeight: 200,
    color: "#595A5A",
  },
  gridstart: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  seemore: {
    fontWeight: 200,
    marginLeft: "0.5rem",
    fontSize: "1rem",
    color: "#E16733",
    cursor: "pointer",
  },
  cardseemore: {
    borderRadius: 8,
    backgroundColor: "#f8f8f6",
    boxShadow: "unset",
  },
  mapcon: { height: "45vh", width: "100%" },
  component: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}));
const Apiwelcome = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const serviceContext = useContext(ServiceContext);
  const [lastindex, setlastindex] = useState(7);
  const lang = langContext.lang.data;
  const [apikey, setapikey] = useState(undefined);

  const initApikey = useCallback(async () => {
    const data = await getoneAPIkey();
    if (data?.data?.length) {
      setapikey(data.data[0].api_key);
    }
  }, []);

  useEffect(() => {
    if (!apikey) {
      initApikey();
    }

    return () => {};
  }, [apikey, initApikey]);
  const showImage = (id) => {
    const filter = Imageservice().filter((rs) => {
      return rs === id;
    });
    if (filter.length !== 0) {
      return (
        <img
          alt={`image_${id}`}
          src={require(`../../../images/graphic-icon/${id}.png`)}
          style={{ width: "1.75rem", height: "auto" }}
        />
      );
    } else {
      return <FaCircle color="#e16733" size={10} />;
    }
  };
  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <Typography className={classes.maintext}>
          {lang.SubtitlesYoucanaccessAPI}
        </Typography>
        {/* <Typography className={classes.detailtext}>
          Usu habeo equidem sanctus no. Suas summo id sed, erat erant oporteat
          cu pri. In eum omnes molestie. Sed ad debet scaevola, ne mel.
        </Typography> */}
      </Card>
      <Card className={classes.cardapi}>
        <Grid container spacing={0}>
          <Grid item md={6} sm={12}>
            <div style={{ margin: "2rem" }}>
              <Typography style={{ fontSize: "1.2rem", color: "#E16733" }}>
                Data API
              </Typography>
              <Typography className={classes.detailtext}>
                {lang.SubtitlesDataService}
              </Typography>
            </div>
          </Grid>
          <Grid item md={6} sm={12}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ margin: "2rem" }}>
                <img
                  alt="api_map"
                  src={require("../../../images/graphic-icon/data_api-01.png")}
                  style={{
                    width: "100%",
                    height: "auto",
                    maxHeight: 360,
                  }}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={{ margin: "0rem 2rem 2rem" }}>
              <Typography className={classes.detailtext}>
                {lang.SubtitlesDataAPIservice}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={{ margin: "0rem 2rem 2rem 2rem" }}>
              <Card className={classes.cardseemore}>
                <div
                  style={{
                    margin: "2rem",
                  }}
                >
                  <Grid container spacing={2}>
                    {serviceContext.data
                      .filter((rs) => {
                        return rs.category === "data";
                      })
                      .slice(0, lastindex)
                      .map((item, index) => {
                        return (
                          <Grid
                            item
                            md={3}
                            sm={6}
                            xs={6}
                            key={`${item.name}_${index}`}
                            className={classes.gridstart}
                          >
                            {showImage(item._id)}
                            <Typography
                              style={{
                                fontWeight: 200,
                                marginLeft: "0.5rem",
                                fontSize: "1rem",
                                color: "#595A5A",
                              }}
                            >
                              {langContext.lang.locale === "th"
                                ? item.name
                                : `${item.endpoint
                                    .split("-")
                                    .join(" ")
                                    .charAt(0)
                                    .toUpperCase()}${item.endpoint
                                    .split("-")
                                    .join(" ")
                                    .slice(1)}`}
                            </Typography>
                          </Grid>
                        );
                      })}
                    <Grid
                      item
                      md={3}
                      sm={4}
                      xs={6}
                      className={classes.gridstart}
                    >
                      <Typography
                        className={classes.seemore}
                        onClick={() => {
                          if (lastindex === 7) {
                            setlastindex(
                              serviceContext.data.filter((rs) => {
                                return rs.category === "data";
                              }).length
                            );
                          } else {
                            setlastindex(7);
                          }
                        }}
                      >
                        {`${
                          lastindex <
                          serviceContext.data.filter((rs) => {
                            return rs.category === "data";
                          }).length
                            ? lang.Seemore
                            : "ย่อ"
                        } ${
                          lastindex <
                          serviceContext.data.filter((rs) => {
                            return rs.category === "data";
                          }).length
                            ? ">>"
                            : "<<"
                        }`}
                      </Typography>
                    </Grid>
                  </Grid>
                </div>
              </Card>
            </div>
          </Grid>
        </Grid>
      </Card>
      {/* <Card className={classes.cardapi}>
        <Grid container spacing={0}>
          <Grid item md={12} sm={12}>
            <div style={{ margin: "2rem" }}>
              <Typography
                style={{
                  fontSize: "1.2rem",
                  color: "#E16733",
                  textAlign: "center",
                }}
              >
                Map API
              </Typography>
              <Typography className={classes.detailtext}>
                {lang.SubtitlesMapService}
              </Typography>
            </div>
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <div style={{ margin: "0rem 2rem 2rem 2rem" }}>
              <div style={{ width: "100%", height: "45vh" }}>
                <iframe
                  title="MEA"
                  width="100%"
                  height="100%"
                  frameborder="0"
                  allow="geolocation"
                  src={`${
                    document.location.hostname === "localhost"
                      ? "http://localhost:3000"
                      : process.env.REACT_APP_WEB_URL
                  }/embed/apikey=${
                    document.location.hostname === "localhost"
                      ? "http://localhost:3000"
                      : apikey
                  }?q=100.554894,13.721237&z=15`}
                ></iframe>
              </div>
            </div>
          </Grid>
        </Grid>
      </Card> */}
    </div>
  );
};

export default Apiwelcome;
